import { DEVICE } from 'constant';
import styled from 'styled-components';

export const SignUpContainer = styled.div`
  display: flex;
  width: 695px;
  height: 480px;
  border: 1px solid black;
  border-radius: 24px;
`;

export const SignUpBackground = styled.div`
  display: flex;
  background-image: url(${(props) => props.bgImg});
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  align-items: center;
  justify-content: center;
  height: 100%;
  flex-direction: column;
  user-select: none;

  @media screen and (max-width: 350px) {
    margin-bottom: 0px;
  }
`;

export const InputContainer = styled.div`
  display: flex;
  width: 100%;

  & > * input::placeholder {
    color: #a6a8ab;
  }
`;

export const InputsContainer = styled.div`
  display: flex;
  flex-direction: column;
  & > :not(:last-child) {
    margin-bottom: 48px;
  }
`;

export const HeadlinesContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: url(${(props) => props.bgImg});
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  width: 308px;
  border-radius: ${(props) => (props.isRtl ? '0 24px 24px 0;' : '24px 0 0 24px;')};
`;

export const MobileHeadlineContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 3%;
  align-items: center;

  & > :first-child {
    margin-bottom: 10px;
  }

  @media screen and (max-width: 350px) {
    margin-bottom: 0px;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  margin-top: 48px;
`;

export const FormContainer = styled.div`
  display: flex;
  margin: 0 5.5%;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  margin-top: ${(props) => props.marginTop};

  @media ${DEVICE.small} {
    margin-top: ${(props) => (props.mobileMarginTop ? props.mobileMarginTop : '0px')};
  }
`;

export const ImgContainer = styled.div``;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ColorBackground = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
  background-color: rgba(47, 54, 69, 0.7);
`;

export const MobileContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Img = styled.img``;

export const SideImage = styled.img`
  height: 100%;
  border-radius: inherit;
`;
